import { readSelectedProject, selectProject } from 'serviceWorker/services/selectedProject';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { selectedProjectContract } from 'shared/domain/selectedProject/selectedProjectContract';
import { runWhenRequestsAllowed } from './runWhenRequestsAllowed';

/**
 * Answers the selected project requests. A switch answers once the previous
 * project's data is cleared; a read waits for a switch in progress.
 */
export function serveSelectedProjectRequests(): ChannelUnsubscribe {
  return channelServer.handle(selectedProjectContract, {
    select: ({ projectId }) => selectProject(projectId),
    getSelected: () => runWhenRequestsAllowed(readSelectedProject),
  });
}
